import React from 'react';
import { Icon, Tooltip } from 'components/common';

import styled from 'styled-components';

const BorderDiv = styled.div`
  border: 2px solid ${p => p.color};
  border-radius: ${p => (p.radius ? p.radius : '100%')};
  height: 23px;
  width: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function RebrandIcon({ previousName, size = 'xs', style = {} }) {
  if (!previousName) {
    return null;
  }

  return (
    <div style={style}>
      <Tooltip title={`Previously called ${previousName}`}>
        <BorderDiv color='#d9d9d9'>
          <Icon size={size} icon='certificate' color='#595959' />
        </BorderDiv>
      </Tooltip>
    </div>
  );
}

RebrandIcon.propTypes = {};

export default RebrandIcon;
